import React from "react";
import { connect } from "react-redux";
import HOC from "../../hoc";
import getUserManager from "../user-manager";
import { ReactComponent as SvgLogout } from "../../assets/logout.svg";
import ButtonIcon from "../../components/ui/ButtonIcon/ButtonIcon";
import "./login-status.scss";

const { withLocalization } = HOC;
const onSignOut = () => {
    const userManager = getUserManager();
    const path = window.location.pathname;
    let url = "/";
    if (path !== "/login") url = path + window.location.search;
    userManager.signoutRedirect({ state: { redirectUrl: url } });
};

const LoginStatus = ({ user, loc, loading }) => {
    if (!user?.profile) return null;
    return (
        <div className="login-status">
            <span className="login-status__user-name">{user.profile.display_name ?? user.profile.email}</span>
            <ButtonIcon
                className="login-status__btn-logout"
                showText={false}
                onClick={onSignOut}
                {...{ disabled: loading, text: loc("pages.login.signOutBtn") }}>
                <SvgLogout />
            </ButtonIcon>
        </div>
    );
};

const mapDispathcToProps = ({ oidc }) => ({
    user: oidc?.user
});
export default connect(mapDispathcToProps)(withLocalization(LoginStatus));
